<div class="copy-project-warning" role="alert">
  <i class="pi pi-exclamation-triangle"></i>
  <p class="copy-project-warning__message">{{ message }}</p>
</div>
